module.exports = __webpack_public_path__ + "static/media/sort-alpha-up-alt.103f89f4.svg";